// ** React Imports
import { useEffect, useRef, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadAccountStore,
    ViewType,
    ActivityDialogStore,
    LeadCompanyStore,
    CompanyDialogStore,
    LeadSprintStore,
    SprintDialogStore,
    LeadActivityHistoryStore,
    ActivityHistoryDialogStore,
    LeadActivityCadenceStore,
    CadenceListDialogStore,
    LeadActivityOutcomeStore,
    ActivityOutcomes,
    LeadActivitySMSStore,
} from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Icon from 'src/features/common/CustomIcon';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { ProblemDetails } from '../../../types/ApiErrorResponse';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import FormControl from '@mui/material/FormControl';
import DoActivityOutcomes from './DoActivityOutcomes';
import Alert from '@mui/material/Alert';
import SendIcon from '@mui/icons-material/Send';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import StandardSkeleton from '../../common/StandardSkeleton';
import HtmlTextAreaView from '../../common2/Templating/HtmlTextAreaView';
import ContentEditor from '../../../v2/components/ContentEditor/ContentEditor';
import { TokenType } from '../../../v2/components/ContentEditor/types/content-editor-types';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

type StatusUpdate = { messageId: string; status: string };

const DoActivityInboundSMS = () => {
    const outcomesRecord = LeadActivityOutcomeStore.useState((s) => s.record);
    const [dataLoaded, setDataLoaded] = useState(false);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead);
    const [phoneFrom, setPhoneFrom] = useState(outcomesRecord.phoneFrom);
    const [phoneTo, setPhoneTo] = useState(outcomesRecord.phoneTo);
    const smsMessage = LeadActivitySMSStore.useState((s) => s.record);
    const [smsBodyError, setSmsBodyError] = useState(false);
    const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
    const [connection, setConnection] = useState<null | HubConnection>(null);
    const latestStatus = useRef({ messageId: '', status: '' } as StatusUpdate);
    const [status, setStatus] = useState<StatusUpdate>({ messageId: '', status: '' });
    const [messageId, setMessageId] = useState('');
    const [sentStatus, setSentStatus] = useState('');
    const [showMessageStatus, setShowMessageStatus] = useState(false);
    latestStatus.current = status;

    useEffect(() => {
        const fetchOutcomes = async () => {
            const response = await client.get(
                leadEndpoints.getactivityoutcomes.replace('{leadid}', '' + selectedLead?.id.toString()),
            );
            LeadActivityOutcomeStore.update((s) => {
                s.record = response.data;
            });
            setPhoneFrom(response.data.phoneFrom);
            setPhoneTo(response.data.phoneTo);

            LeadActivitySMSStore.update((s) => {
                s.record.leadId = response.data.leadId;
            });
            LeadActivitySMSStore.update((s) => {
                s.record.smsBody = response.data.smsBody;
            });
            LeadActivitySMSStore.update((s) => {
                s.record.phoneFrom = response.data.phoneFrom;
            });
            setDataLoaded(true);
        };
        if (selectedLead != null) fetchOutcomes();
    }, []);

    const handleBodyTextChange = (value: string) => {
        LeadActivityOutcomeStore.update((s) => {
            s.record.smsBody = value;
        });
        LeadActivitySMSStore.update((s) => {
            s.record.smsBody = value;
        });
    };

    if (dataLoaded) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box>
                                    <Grid container alignContent="left" spacing={2}>
                                        <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                            <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                Incoming SMS
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            alignContent="left"
                                            justifyContent={'left'}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <FormControl fullWidth>
                                                <TextField
                                                    label="From"
                                                    id="email-from"
                                                    value={outcomesRecord.phoneFrom}
                                                    size="small"
                                                    disabled={true}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            alignContent="left"
                                            justifyContent={'left'}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <FormControl fullWidth>
                                                <ContentEditor
                                                    sx={{ height: 150 }}
                                                    html={outcomesRecord.smsBody}
                                                    onChange={handleBodyTextChange}
                                                    disabled={true}
                                                    error={false}
                                                    tokenType={TokenType.None}
                                                    showToolbar={false}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            alignContent="left"
                                            justifyContent={'left'}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <DoActivityOutcomes />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return <StandardSkeleton />;
    }
};

export { DoActivityInboundSMS };

export default DoActivityInboundSMS;
